import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { Section, SectionTitle } from './Shared';
export function Solution() {
  return <div className="bg-cream" data-id="element-203">
      <Section data-id="element-204">
        <SectionTitle className="mb-12" data-id="element-205">
          Qué vas a encontrar dentro de la guía
        </SectionTitle>
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-206">
          {/* Left Content - Benefits List */}
          <div className="order-2 lg:order-1" data-id="element-207">
            <div className="space-y-6 mb-10" data-id="element-208">
              {['Actividades fáciles según edad', 'Ideas sin materiales caros', 'Estimulación en casa', 'Juegos sensoriales', 'Desarrollo del lenguaje y motricidad', 'Rutinas reales y flexibles'].map((item, i) => <div key={i} className="flex items-center gap-4 bg-white p-4 rounded-xl shadow-sm border border-beige-muted/30" data-id="element-209">
                  <CheckCircle2 className="w-6 h-6 text-sage-dark flex-shrink-0" data-id="element-210" />
                  <p className="text-lg text-charcoal font-medium" data-id="element-211">{item}</p>
                </div>)}
            </div>

            <div className="bg-sage-light/30 p-6 rounded-2xl border border-sage/40 relative overflow-hidden" data-id="element-212">
              <div className="absolute top-0 left-0 w-2 h-full bg-sage-dark" data-id="element-213"></div>
              <p className="text-charcoal font-medium text-lg leading-relaxed italic" data-id="element-214">
                "No es teoría complicada. Son actividades simples para aplicar
                en la vida real."
              </p>
            </div>
          </div>

          {/* Right Content - Mockup */}
          <div className="relative order-1 lg:order-2 flex justify-center" data-id="element-215">
            <div className="absolute inset-0 bg-gold-light/30 rounded-full blur-[80px] -z-10" data-id="element-216"></div>
            <img src="https://cdn.magicpatterns.com/uploads/2ziVexfWghWU1m6qWpaeto/hacer_una_version_distinta_mas_202605091951.jpg" alt="Interior de la guía" className="w-full max-w-md lg:max-w-full h-auto object-contain drop-shadow-xl rounded-2xl" data-id="element-217" />
          </div>
        </div>
      </Section>
    </div>;
}